"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _ClientSummary = _interopRequireDefault(require("./ClientSummary"));

require("../styles/_clients.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MAX_INITIAL_VISIBLE_CLIENTS = 6;
var MAX_LOAD_MORE_CLIENTS = 3;

var Clients = /*#__PURE__*/function (_Component) {
  _inherits(Clients, _Component);

  function Clients(props) {
    var _this;

    _classCallCheck(this, Clients);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Clients).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "loadMore", function () {
      var items = _this.props.items;
      var itemsRendered = _this.state.itemsRendered;

      _this.setState({
        itemsRendered: Math.min(itemsRendered + MAX_LOAD_MORE_CLIENTS, items.length)
      });
    });

    var _items = props.items;
    _this.state = {
      itemsRendered: Math.min(MAX_INITIAL_VISIBLE_CLIENTS, _items.length)
    };
    return _this;
  }

  _createClass(Clients, [{
    key: "renderHeader",
    value: function renderHeader() {
      var items = this.props.items;
      var suffix = "Client".concat(items.length === 1 ? '' : 's');
      return _react.default.createElement("div", {
        className: "clients-header"
      }, _react.default.createElement("div", {
        className: "clients-header__title"
      }, _react.default.createElement(_uiKit.Icon, {
        name: "organisation",
        color: "russian",
        size: 20
      }), _react.default.createElement("span", {
        className: "clients-title"
      }, "".concat(suffix, " (").concat(items.length, ")"))));
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var items = this.props.items;
      var itemsRendered = this.state.itemsRendered;
      return _react.default.createElement("div", {
        className: "clients-body"
      }, items.slice(0, itemsRendered).map(function (item, index) {
        var key = "".concat(index, "-client");
        return _react.default.createElement(_ClientSummary.default, _extends({}, item, {
          key: key
        }));
      }));
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var items = this.props.items;
      var itemsRendered = this.state.itemsRendered;
      return itemsRendered >= items.length ? null : _react.default.createElement("div", {
        className: "clients-footer"
      }, _react.default.createElement(_uiKit.LinkButton, {
        onClick: this.loadMore,
        className: "clients-view-more"
      }, "View More"));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "clients"
      }, this.renderHeader(), this.renderItems(), this.renderFooter());
    }
  }]);

  return Clients;
}(_react.Component);

exports.default = Clients;

_defineProperty(Clients, "displayName", 'Clients');